import { createAsyncThunk } from '@reduxjs/toolkit';
import { affinityHubService } from '../../services';

const getScoreByAffinity = createAsyncThunk(
    'affinityHub/getScoreByAffinity',
    async (payload, ThunkAPI) => {
        try{
            const response = await affinityHubService.getScoreByAffinity();
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getYearsOfExperience = createAsyncThunk(
    'affinityHub/getYearsOfExperience',
    async (payload, ThunkAPI) => {
        try{
            const response = await affinityHubService.getYearsOfExperience();
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getSpecialtiesData = createAsyncThunk(
    'affinityHub/getSpecialtiesData',
    async (payload, ThunkAPI) => {
        try{
            const response = await affinityHubService.getSpecialtiesData();
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getDistributionByLocation = createAsyncThunk(
    'affinityHub/getDistributionByLocation',
    async (payload, ThunkAPI) => {
        try{
            const response = await affinityHubService.getDistributionByLocation();
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getDigitalVsNonDigitalAffinity = createAsyncThunk(
    'affinityHub/getDigitalVsNonDigitalAffinity',
    async (payload, ThunkAPI) => {
        try{
            const response = await affinityHubService.getDigitalVsNonDigitalAffinity();
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getAffinityBySegment = createAsyncThunk(
    'affinityHub/getAffinityBySegment',
    async (payload, ThunkAPI) => {
        try{
            const response = await affinityHubService.getAffinityBySegment();
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getPersonalPromotionChannelAffinity = createAsyncThunk(
    'affinityHub/getPersonalPromotionChannelAffinity',
    async (payload, ThunkAPI) => {
        try{
            const response = await affinityHubService.getPersonalPromotionChannelAffinity();
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getPeerPeerAffinityData = createAsyncThunk(
    'affinityHub/getPeerPeerAffinityData',
    async (payload, ThunkAPI) => {
        try{
            const response = await affinityHubService.getPeerPeerAffinityData();
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getDynamicTopicCounts = createAsyncThunk(
    'affinityHub/getDynamicTopicCounts',
    async (payload, ThunkAPI) => {
        try{
            const response = await affinityHubService.getDynamicTopicCounts();
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getBrandedUnbrandedCounts = createAsyncThunk(
    'affinityHub/getBrandedUnbrandedCounts',
    async (payload, ThunkAPI) => {
        try{
            const response = await affinityHubService.getBrandedUnbrandedCounts();
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getDistributionByYearsOfExperience = createAsyncThunk(
    'affinityHub/getDistributionByYearsOfExperience',
    async (payload, ThunkAPI) => {
        try{
            const response = await affinityHubService.getDistributionByYearsOfExperience();
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getRegionCount = createAsyncThunk(
    'affinityHub/getRegionCount',
    async (payload, ThunkAPI) => {
        try{
            const response = await affinityHubService.getRegionCount();
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getDigitalChannelAffinity = createAsyncThunk(
    'affinityHub/getDigitalChannelAffinity',
    async (payload, ThunkAPI) => {
        try{
            const response = await affinityHubService.getDigitalChannelAffinity();
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);
const data = {
    'keywords': {
        'keywords1': [
            {
                'content': 'substance abuse treatment',
                'count': 0.0113,
                'specialization_category': 'Addiction Medicine'
            },
            {
                'content': 'health agencies',
                'count': 0.001,
                'specialization_category': 'Agencies'
            },
            {
                'content': 'allergy',
                'count': 0.0759,
                'specialization_category': 'Allergy and Immunology'
            },
            {
                'content': 'medical practice',
                'count': 0.1517,
                'specialization_category': 'Allopathic & Osteopathic Physicians'
            },
            {
                'content': 'outpatient services',
                'count': 0.0108,
                'specialization_category': 'Ambulatory Health Care Facilities'
            },
            {
                'content': 'anesthesia',
                'count': 3.5278,
                'specialization_category': 'Anesthesiology'
            },
            {
                'content': 'mental health',
                'count': 0.0542,
                'specialization_category': 'Behavioral Health & Social Service Providers'
            },
            {
                'content': 'heart',
                'count': 3.3465,
                'specialization_category': 'Cardiology'
            },
            {
                'content': 'chiropractic care',
                'count': 0.0025,
                'specialization_category': 'Chiropractic Providers'
            },
            {
                'content': 'colorectal operations',
                'count': 0.1409,
                'specialization_category': 'Colon & Rectal Surgery'
            },
            {
                'content': 'dental services',
                'count': 0.0108,
                'specialization_category': 'Dental Providers'
            },
            {
                'content': 'dental care',
                'count': 0.0453,
                'specialization_category': 'Dentist'
            },
            {
                'content': 'skin',
                'count': 0.3482,
                'specialization_category': 'Dermatology'
            },
            {
                'content': 'nutrition counseling',
                'count': 0.0236,
                'specialization_category': 'Dietary & Nutritional Service Providers'
            },
            {
                'content': 'emergency',
                'count': 3.5899,
                'specialization_category': 'Emergency Medicine'
            },
            {
                'content': 'hormones',
                'count': 0.7591,
                'specialization_category': 'Endocrinology'
            },
            {
                'content': 'eye care',
                'count': 0.0207,
                'specialization_category': 'Eye & Vision Service Providers'
            },
            {
                'content': 'general health',
                'count': 8.2156,
                'specialization_category': 'Family Medicine'
            },
            {
                'content': 'digestive system',
                'count': 1.5777,
                'specialization_category': 'Gastroenterology'
            },
            {
                'content': 'blood diseases',
                'count': 0.5024,
                'specialization_category': 'Hematology'
            },
            {
                'content': 'end-of-life care',
                'count': 0.0148,
                'specialization_category': 'Hospice & Palliative Medicine'
            },
            {
                'content': 'hospital care',
                'count': 0.0473,
                'specialization_category': 'Hospitals'
            },
            {
                'content': 'internal organs',
                'count': 15.2451,
                'specialization_category': 'Internal Medicine'
            },
            {
                'content': 'medical testing',
                'count': 0.0379,
                'specialization_category': 'Laboratories'
            },
            {
                'content': 'genetic disorders',
                'count': 0.0502,
                'specialization_category': 'Medical Genetics and Genomics'
            },
            {
                'content': 'kidneys',
                'count': 1.0502,
                'specialization_category': 'Nephrology'
            },
            {
                'content': 'brain surgery',
                'count': 0.3832,
                'specialization_category': 'Neurological Surgery'
            },
            {
                'content': 'musculoskeletal disorders',
                'count': 0.0123,
                'specialization_category': 'Neuromusculoskeletal Medicine'
            },
            {
                'content': 'radiopharmaceuticals',
                'count': 0.1281,
                'specialization_category': 'Nuclear Medicine'
            },
            {
                'content': 'nursing care',
                'count': 23.3504,
                'specialization_category': 'Nursing Service Providers'
            },
            {
                'content': 'pregnancy',
                'count': 2.6707,
                'specialization_category': 'Obstetrics & Gynecology'
            },
            {
                'content': 'cancer',
                'count': 7.1645,
                'specialization_category': 'Oncology'
            },
            {
                'content': 'eye diseases',
                'count': 0.3005,
                'specialization_category': 'Ophthalmology'
            },
            {
                'content': 'jaw surgery',
                'count': 0.0177,
                'specialization_category': 'Oral & Maxillofacial Surgery'
            },
            {
                'content': 'bones',
                'count': 0.4556,
                'specialization_category': 'Orthopedic Surgery'
            },
            {
                'content': 'healthcare services',
                'count': 0.8916,
                'specialization_category': 'Other Service Providers'
            },
            {
                'content': 'ear',
                'count': 0.3709,
                'specialization_category': 'Otolaryngology'
            },
            {
                'content': 'pain management',
                'count': 0.0453,
                'specialization_category': 'Pain Medicine'
            },
            {
                'content': 'tissue analysis',
                'count': 3.3766,
                'specialization_category': 'Pathology'
            },
            {
                'content': 'children',
                'count': 3.4756,
                'specialization_category': 'Pediatrics'
            },
            {
                'content': 'medications',
                'count': 0.3251,
                'specialization_category': 'Pharmacy Service Providers'
            },
            {
                'content': 'physiatry',
                'count': 0.3069,
                'specialization_category': 'Physical Medicine & Rehabilitation'
            },
            {
                'content': 'cosmetic surgery',
                'count': 0.1931,
                'specialization_category': 'Plastic Surgery'
            },
            {
                'content': 'foot and ankle care',
                'count': 0.1813,
                'specialization_category': 'Podiatric Medicine & Surgery Service Providers'
            },
            {
                'content': 'preventive healthcare',
                'count': 0.0305,
                'specialization_category': 'Preventive Medicine'
            },
            {
                'content': 'primary healthcare',
                'count': 0.0034,
                'specialization_category': 'Primary Care Clinic/Center'
            },
            {
                'content': 'mental disorders',
                'count': 1.0546,
                'specialization_category': 'Psychiatry & Neurology'
            },
            {
                'content': 'imaging',
                'count': 6.5867,
                'specialization_category': 'Radiology'
            },
            {
                'content': 'long-term care',
                'count': 0.0015,
                'specialization_category': 'Residential Treatment Facilities'
            },
            {
                'content': 'respiratory therapy',
                'count': 0.0823,
                'specialization_category': 'Respiratory, Developmental, Rehabilitative, and Restorative Service Providers'
            },
            {
                'content': 'joints',
                'count': 0.7911,
                'specialization_category': 'Rheumatology'
            },
            {
                'content': 'speech therapy',
                'count': 0.0094,
                'specialization_category': 'Speech, Language and Hearing Service Providers'
            },
            {
                'content': 'athletic injuries',
                'count': 0.0172,
                'specialization_category': 'Sports Medicine'
            },
            {
                'content': 'medical education',
                'count': 3.4928,
                'specialization_category': 'Student, Health Care'
            },
            {
                'content': 'medical supplies',
                'count': 0.0025,
                'specialization_category': 'Suppliers'
            },
            {
                'content': 'surgical procedures',
                'count': 1.7102,
                'specialization_category': 'Surgery'
            },
            {
                'content': 'cancer surgery',
                'count': 0.3285,
                'specialization_category': 'Surgical Oncology'
            },
            {
                'content': 'urinary system',
                'count': 3.1249,
                'specialization_category': 'Urology'
            },
            {
                'content': 'blood vessel surgery',
                'count': 0.2537,
                'specialization_category': 'Vascular Surgery'
            }
        ],
        'keywords2': [
            {
                'content': 'addiction recovery',
                'count': 0.0113,
                'specialization_category': 'Addiction Medicine'
            },
            {
                'content': 'medical services',
                'count': 0.001,
                'specialization_category': 'Agencies'
            },
            {
                'content': 'immune system',
                'count': 0.0759,
                'specialization_category': 'Allergy and Immunology'
            },
            {
                'content': 'allopathy',
                'count': 0.1517,
                'specialization_category': 'Allopathic & Osteopathic Physicians'
            },
            {
                'content': 'ambulatory care',
                'count': 0.0108,
                'specialization_category': 'Ambulatory Health Care Facilities'
            },
            {
                'content': 'pain management',
                'count': 3.5278,
                'specialization_category': 'Anesthesiology'
            },
            {
                'content': 'counseling',
                'count': 0.0542,
                'specialization_category': 'Behavioral Health & Social Service Providers'
            },
            {
                'content': 'cardiovascular',
                'count': 3.3465,
                'specialization_category': 'Cardiology'
            },
            {
                'content': 'spinal adjustments',
                'count': 0.0025,
                'specialization_category': 'Chiropractic Providers'
            },
            {
                'content': 'colon surgery',
                'count': 0.1409,
                'specialization_category': 'Colon & Rectal Surgery'
            },
            {
                'content': 'oral care providers',
                'count': 0.0108,
                'specialization_category': 'Dental Providers'
            },
            {
                'content': 'oral health',
                'count': 0.0453,
                'specialization_category': 'Dentist'
            },
            {
                'content': 'dermatitis',
                'count': 0.3482,
                'specialization_category': 'Dermatology'
            },
            {
                'content': 'dietary services',
                'count': 0.0236,
                'specialization_category': 'Dietary & Nutritional Service Providers'
            },
            {
                'content': 'trauma',
                'count': 3.5899,
                'specialization_category': 'Emergency Medicine'
            },
            {
                'content': 'metabolism',
                'count': 0.7591,
                'specialization_category': 'Endocrinology'
            },
            {
                'content': 'vision health',
                'count': 0.0207,
                'specialization_category': 'Eye & Vision Service Providers'
            },
            {
                'content': 'preventive care',
                'count': 8.2156,
                'specialization_category': 'Family Medicine'
            },
            {
                'content': 'gastrointestinal',
                'count': 1.5777,
                'specialization_category': 'Gastroenterology'
            },
            {
                'content': 'hematologic disorders',
                'count': 0.5024,
                'specialization_category': 'Hematology'
            },
            {
                'content': 'palliative treatments',
                'count': 0.0148,
                'specialization_category': 'Hospice & Palliative Medicine'
            },
            {
                'content': 'medical treatment',
                'count': 0.0473,
                'specialization_category': 'Hospitals'
            },
            {
                'content': 'disease management',
                'count': 15.2451,
                'specialization_category': 'Internal Medicine'
            },
            {
                'content': 'diagnostic lab',
                'count': 0.0379,
                'specialization_category': 'Laboratories'
            },
            {
                'content': 'DNA analysis',
                'count': 0.0502,
                'specialization_category': 'Medical Genetics and Genomics'
            },
            {
                'content': 'dialysis',
                'count': 1.0502,
                'specialization_category': 'Nephrology'
            },
            {
                'content': 'neurosurgery',
                'count': 0.3832,
                'specialization_category': 'Neurological Surgery'
            },
            {
                'content': 'osteopathic medicine',
                'count': 0.0123,
                'specialization_category': 'Neuromusculoskeletal Medicine'
            },
            {
                'content': 'diagnostic imaging',
                'count': 0.1281,
                'specialization_category': 'Nuclear Medicine'
            },
            {
                'content': 'patient support',
                'count': 23.3504,
                'specialization_category': 'Nursing Service Providers'
            },
            {
                'content': 'women’s health',
                'count': 2.6707,
                'specialization_category': 'Obstetrics & Gynecology'
            },
            {
                'content': 'tumors',
                'count': 7.1645,
                'specialization_category': 'Oncology'
            },
            {
                'content': 'vision care',
                'count': 0.3005,
                'specialization_category': 'Ophthalmology'
            },
            {
                'content': 'facial reconstruction',
                'count': 0.0177,
                'specialization_category': 'Oral & Maxillofacial Surgery'
            },
            {
                'content': 'joints surgery',
                'count': 0.4556,
                'specialization_category': 'Orthopedic Surgery'
            },
            {
                'content': 'miscellaneous healthcare',
                'count': 0.8916,
                'specialization_category': 'Other Service Providers'
            },
            {
                'content': 'nose',
                'count': 0.3709,
                'specialization_category': 'Otolaryngology'
            },
            {
                'content': 'chronic pain therapy',
                'count': 0.0453,
                'specialization_category': 'Pain Medicine'
            },
            {
                'content': 'disease diagnosis',
                'count': 3.3766,
                'specialization_category': 'Pathology'
            },
            {
                'content': 'pediatric care',
                'count': 3.4756,
                'specialization_category': 'Pediatrics'
            },
            {
                'content': 'pharmacy services',
                'count': 0.3251,
                'specialization_category': 'Pharmacy Service Providers'
            },
            {
                'content': 'rehabilitative medicine',
                'count': 0.3069,
                'specialization_category': 'Physical Medicine & Rehabilitation'
            },
            {
                'content': 'reconstructive surgery',
                'count': 0.1931,
                'specialization_category': 'Plastic Surgery'
            },
            {
                'content': 'podiatry',
                'count': 0.1813,
                'specialization_category': 'Podiatric Medicine & Surgery Service Providers'
            },
            {
                'content': 'wellness and prevention',
                'count': 0.0305,
                'specialization_category': 'Preventive Medicine'
            },
            {
                'content': 'general practice',
                'count': 0.0034,
                'specialization_category': 'Primary Care Clinic/Center'
            },
            {
                'content': 'brain health',
                'count': 1.0546,
                'specialization_category': 'Psychiatry & Neurology'
            },
            {
                'content': 'diagnostic tests',
                'count': 6.5867,
                'specialization_category': 'Radiology'
            },
            {
                'content': 'residential health',
                'count': 0.0015,
                'specialization_category': 'Residential Treatment Facilities'
            },
            {
                'content': 'rehabilitation',
                'count': 0.0823,
                'specialization_category': 'Respiratory, Developmental, Rehabilitative, and Restorative Service Providers'
            },
            {
                'content': 'arthritis',
                'count': 0.7911,
                'specialization_category': 'Rheumatology'
            },
            {
                'content': 'audiology',
                'count': 0.0094,
                'specialization_category': 'Speech, Language and Hearing Service Providers'
            },
            {
                'content': 'sports health',
                'count': 0.0172,
                'specialization_category': 'Sports Medicine'
            },
            {
                'content': 'healthcare training',
                'count': 3.4928,
                'specialization_category': 'Student, Health Care'
            },
            {
                'content': 'healthcare equipment',
                'count': 0.0025,
                'specialization_category': 'Suppliers'
            },
            {
                'content': 'operative care',
                'count': 1.7102,
                'specialization_category': 'Surgery'
            },
            {
                'content': 'oncologic surgery',
                'count': 0.3285,
                'specialization_category': 'Surgical Oncology'
            },
            {
                'content': 'kidneys',
                'count': 3.1249,
                'specialization_category': 'Urology'
            },
            {
                'content': 'vascular health',
                'count': 0.2537,
                'specialization_category': 'Vascular Surgery'
            }
        ],
        'keywords3': [
            {
                'content': 'dependency health',
                'count': 0.0113,
                'specialization_category': 'Addiction Medicine'
            },
            {
                'content': 'healthcare administration',
                'count': 0.001,
                'specialization_category': 'Agencies'
            },
            {
                'content': 'antibodies',
                'count': 0.0759,
                'specialization_category': 'Allergy and Immunology'
            },
            {
                'content': 'osteopathy',
                'count': 0.1517,
                'specialization_category': 'Allopathic & Osteopathic Physicians'
            },
            {
                'content': 'health clinics',
                'count': 0.0108,
                'specialization_category': 'Ambulatory Health Care Facilities'
            },
            {
                'content': 'surgery',
                'count': 3.5278,
                'specialization_category': 'Anesthesiology'
            },
            {
                'content': 'social work',
                'count': 0.0542,
                'specialization_category': 'Behavioral Health & Social Service Providers'
            },
            {
                'content': 'disease',
                'count': 3.3465,
                'specialization_category': 'Cardiology'
            },
            {
                'content': 'musculoskeletal health',
                'count': 0.0025,
                'specialization_category': 'Chiropractic Providers'
            },
            {
                'content': 'rectal treatment',
                'count': 0.1409,
                'specialization_category': 'Colon & Rectal Surgery'
            },
            {
                'content': 'dentistry',
                'count': 0.0108,
                'specialization_category': 'Dental Providers'
            },
            {
                'content': 'teeth treatment',
                'count': 0.0453,
                'specialization_category': 'Dentist'
            },
            {
                'content': 'acne',
                'count': 0.3482,
                'specialization_category': 'Dermatology'
            },
            {
                'content': 'food and health',
                'count': 0.0236,
                'specialization_category': 'Dietary & Nutritional Service Providers'
            },
            {
                'content': 'acute care',
                'count': 3.5899,
                'specialization_category': 'Emergency Medicine'
            },
            {
                'content': 'diabetes',
                'count': 0.7591,
                'specialization_category': 'Endocrinology'
            },
            {
                'content': 'optometry',
                'count': 0.0207,
                'specialization_category': 'Eye & Vision Service Providers'
            },
            {
                'content': 'family',
                'count': 8.2156,
                'specialization_category': 'Family Medicine'
            },
            {
                'content': 'liver',
                'count': 1.5777,
                'specialization_category': 'Gastroenterology'
            },
            {
                'content': 'blood cell health',
                'count': 0.5024,
                'specialization_category': 'Hematology'
            },
            {
                'content': 'hospice services',
                'count': 0.0148,
                'specialization_category': 'Hospice & Palliative Medicine'
            },
            {
                'content': 'health facilities',
                'count': 0.0473,
                'specialization_category': 'Hospitals'
            },
            {
                'content': 'preventive care',
                'count': 15.2451,
                'specialization_category': 'Internal Medicine'
            },
            {
                'content': 'biological analysis',
                'count': 0.0379,
                'specialization_category': 'Laboratories'
            },
            {
                'content': 'genomic medicine',
                'count': 0.0502,
                'specialization_category': 'Medical Genetics and Genomics'
            },
            {
                'content': 'renal disease',
                'count': 1.0502,
                'specialization_category': 'Nephrology'
            },
            {
                'content': 'spinal operations',
                'count': 0.3832,
                'specialization_category': 'Neurological Surgery'
            },
            {
                'content': 'joint health',
                'count': 0.0123,
                'specialization_category': 'Neuromusculoskeletal Medicine'
            },
            {
                'content': 'radiation therapy',
                'count': 0.1281,
                'specialization_category': 'Nuclear Medicine'
            },
            {
                'content': 'healthcare nursing',
                'count': 23.3504,
                'specialization_category': 'Nursing Service Providers'
            },
            {
                'content': 'gynecology',
                'count': 2.6707,
                'specialization_category': 'Obstetrics & Gynecology'
            },
            {
                'content': 'chemotherapy',
                'count': 7.1645,
                'specialization_category': 'Oncology'
            },
            {
                'content': 'ophthalmic surgery',
                'count': 0.3005,
                'specialization_category': 'Ophthalmology'
            },
            {
                'content': 'oral operations',
                'count': 0.0177,
                'specialization_category': 'Oral & Maxillofacial Surgery'
            },
            {
                'content': 'orthopedics',
                'count': 0.4556,
                'specialization_category': 'Orthopedic Surgery'
            },
            {
                'content': 'varied services',
                'count': 0.8916,
                'specialization_category': 'Other Service Providers'
            },
            {
                'content': 'throat',
                'count': 0.3709,
                'specialization_category': 'Otolaryngology'
            },
            {
                'content': 'analgesia',
                'count': 0.0453,
                'specialization_category': 'Pain Medicine'
            },
            {
                'content': 'laboratory medicine',
                'count': 3.3766,
                'specialization_category': 'Pathology'
            },
            {
                'content': 'child health',
                'count': 3.4756,
                'specialization_category': 'Pediatrics'
            },
            {
                'content': 'prescription drugs',
                'count': 0.3251,
                'specialization_category': 'Pharmacy Service Providers'
            },
            {
                'content': 'physical therapy',
                'count': 0.3069,
                'specialization_category': 'Physical Medicine & Rehabilitation'
            },
            {
                'content': 'aesthetic procedures',
                'count': 0.1931,
                'specialization_category': 'Plastic Surgery'
            },
            {
                'content': 'foot surgery',
                'count': 0.1813,
                'specialization_category': 'Podiatric Medicine & Surgery Service Providers'
            },
            {
                'content': 'prophylactic medicine',
                'count': 0.0305,
                'specialization_category': 'Preventive Medicine'
            },
            {
                'content': 'family medicine center',
                'count': 0.0034,
                'specialization_category': 'Primary Care Clinic/Center'
            },
            {
                'content': 'neurological diseases',
                'count': 1.0546,
                'specialization_category': 'Psychiatry & Neurology'
            },
            {
                'content': 'X-ray',
                'count': 6.5867,
                'specialization_category': 'Radiology'
            },
            {
                'content': 'treatment centers',
                'count': 0.0015,
                'specialization_category': 'Residential Treatment Facilities'
            },
            {
                'content': 'restorative care',
                'count': 0.0823,
                'specialization_category': 'Respiratory, Developmental, Rehabilitative, and Restorative Service Providers'
            },
            {
                'content': 'autoimmune diseases',
                'count': 0.7911,
                'specialization_category': 'Rheumatology'
            },
            {
                'content': 'language disorders',
                'count': 0.0094,
                'specialization_category': 'Speech, Language and Hearing Service Providers'
            },
            {
                'content': 'exercise medicine',
                'count': 0.0172,
                'specialization_category': 'Sports Medicine'
            },
            {
                'content': 'student health',
                'count': 3.4928,
                'specialization_category': 'Student, Health Care'
            },
            {
                'content': 'pharmaceuticals',
                'count': 0.0025,
                'specialization_category': 'Suppliers'
            },
            {
                'content': 'surgery',
                'count': 1.7102,
                'specialization_category': 'Surgery'
            },
            {
                'content': 'tumor removal',
                'count': 0.3285,
                'specialization_category': 'Surgical Oncology'
            },
            {
                'content': 'bladder',
                'count': 3.1249,
                'specialization_category': 'Urology'
            },
            {
                'content': 'angioplasty',
                'count': 0.2537,
                'specialization_category': 'Vascular Surgery'
            }
        ]
    },
    'total_keywords1_count': 59,
    'total_keywords2_count': 59,
    'total_keywords3_count': 59,
    'status': 200
};
const getContentAffinityKeywords = createAsyncThunk(
    'affinityHub/getContentAffinityKeywords',
    async (payload, ThunkAPI) => {
        try{
            const response = await affinityHubService.getContentAffinityKeywords();
            return data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getVendorAffinity = createAsyncThunk(
    'affinityHub/getVendorAffinity',
    async (payload, ThunkAPI) => {
        try{
            const response = await affinityHubService.getVendorAffinity();
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

export {
    getScoreByAffinity,
    getYearsOfExperience,
    getSpecialtiesData,
    getDistributionByLocation,
    getDigitalVsNonDigitalAffinity,
    getAffinityBySegment,
    getPersonalPromotionChannelAffinity,
    getDynamicTopicCounts,
    getPeerPeerAffinityData,
    getBrandedUnbrandedCounts,
    getDistributionByYearsOfExperience,
    getRegionCount,
    getDigitalChannelAffinity,
    getContentAffinityKeywords,
    getVendorAffinity
};